import generateHash from '../generateHash';
import { BASE_PATH } from '../../../constants';

/**
 * Generates path string with CFI (hash) before query params: path#cfi?params
 * so that CFI fragment is not confused with query string (e.g. colons in CFI).
 *
 * @method generatePath
 * @param {BookLocation} location - BookLocation object to use to derive url
 * @param {URLSearchParams} searchParams - query parameters to include after the hash
 * @returns {String} path string (path#hash?params)
 */
const generatePath = (bookLocation, searchParams = new URLSearchParams()) => {
  const pathname = `${BASE_PATH}/${bookLocation.book.pk}/${bookLocation.document.number}/`;
  const hashContent = generateHash(bookLocation);
  const queryString = searchParams.toString();

  let path;
  if (queryString) {
    path = `${pathname}${hashContent}?${queryString}`;
  } else {
    path = pathname + hashContent;
  }
  return path;
};

export default generatePath;
